/**
 * @file ShouldBeRunning.jsx
 * @exports ShouldBeRunning
 */
import React from 'react'

const red = '#D00000'
const defaultColor = red

const ShouldBeRunning = function ShouldBeRunning ({ style }) {
  return (
    <svg
      id='stopped-icon'
      preserveAspectRatio='xMidYMid meet'
      style={style}
      viewBox='0 0 18 18'
    >
      <description>equipment should be running icon</description>
      <title>should be running</title>
      <path fill={defaultColor} d='M9,0 l-5,12 l5,0 l0,7 l5,-10 l-5,0 Z' />
    </svg>
  )
}

export default ShouldBeRunning
